import logout from "./logout";

const processResponse = async (auth, resType, refreshAttempts) => {
    // console.log("invsess");
    // console.log(resType);
    
    if(refreshAttempts >= 2 || resType === "sessionError"){
        console.log("logout");
        
        // await auth.logout();
        return [false, null];
    }

    if(resType === "refreshToken"){
        // console.log("refreshToken");
        return [false, "refresh"];
    }
    else if(resType === "refreshTokenLanding"){
        // console.log("refreshTokenLanding");
        return [false, "refreshLanding"];
    }else{
        // console.log("hufbvhhb");
        
        return [true, null];
    }
}

export default processResponse;